<template>
  <div class="hosts">
    <v-dialog v-model="addDialog" width="1000">
      <HostsAdd @close="addDialog = false" @added="reload()" />
    </v-dialog>
    <v-container fluid grid-list-md class="pb-0">
      <HostsFilter
        @update="updateAndSearch($event)"
        @showAddDialog="addDialog = true"
        class="mt-2"
      ></HostsFilter>
    </v-container>
    <v-flex v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-flex>
    <div v-else>
      <div
        v-if="hosts.count === 0"
        class="grey--text mt-5"
        style="text-align: center;"
      >
        Aucun résultat
      </div>
      <HostsGrid :hosts="hosts" v-if="settings.view === 1" />
      <HostsTable :hosts="hosts" v-else />
      <v-container fluid>
        <v-layout row justify-center>
          <v-btn @click="loadPage(hosts.page - 1)" :disabled="hosts.page === 0"
            >Page précédente</v-btn
          >
          <v-btn
            @click="loadPage(hosts.page + 1)"
            :disabled="hosts.page === pagesCount"
            >Page suivante</v-btn
          >
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import HostsGrid from "../components/HostsGrid";
import debounce from "lodash.debounce";
import HostsFilter from "../components/HostsFilter";
import { DEFAULT_HOST_FILTERS_SETTINGS } from "../data/DefaultSettings";
import HostsTable from "../components/HostsTable";
import HostsAdd from "../components/HostsAdd";
import { mapActions, mapState } from "vuex";

export default {
  name: "hosts",
  components: {
    HostsTable,
    HostsFilter,
    HostsGrid,
    HostsAdd
  },
  data() {
    return {
      loading: true,
      settings: DEFAULT_HOST_FILTERS_SETTINGS,
      addDialog: false
    };
  },
  methods: {
    ...mapActions("hosts", ["fetchHosts"]),

    async loadPage(page) {
      this.loading = true;
      this.fetchHosts({
        page,
        search: this.settings.search,
        filters: this.settings.filters
      });
      this.loading = false;
    },

    updateAndSearch: debounce(function(settings) {
      this.settings = settings;
      this.fetchHosts({
        page: 0,
        search: settings.search,
        filters: settings.filters
      });
    }, 200),

    reload() {
      this.addDialog = false;
      this.loadPage(this.hosts.page);
    }
  },
  async mounted() {
    await this.fetchHosts({
      page: 0,
      filters: this.settings.filters
    });
    this.loading = false;
  },
  computed: {
    ...mapState("hosts", ["hosts"]),

    pagesCount() {
      return (
        Math.floor(this.hosts.count / 60) + (this.hosts.count % 60 > 0 ? 1 : 0)
      );
    }
  }
};
</script>

<style scoped></style>
